module.exports = __webpack_public_path__ + "img/step2.536aebe4.png";